class BaseMixpanelTracker {
  constructor(presentation) {
    this.presentation = presentation
  }

  setCustomProps(props) {
    this.customProps = props
  }

  getCustomProps() {
    return this.customProps
  }
}

export default BaseMixpanelTracker
